/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Fields2 from "./components/field2";
import form2 from "./schema/form2";
import initialValues2 from "./schema/initialValues2";
import validation2 from "./schema/validations2";
import Table2 from "./components/table2";
import Fields3 from "./components/field3";
import form3 from "./schema/form3";
import initialValues3 from "./schema/initialValues3";
import validation3 from "./schema/validations3";
import Table3 from "./components/table3";
import Fields4 from "./components/field4";
import form4 from "./schema/form4";
import initialValues4 from "./schema/initialValues4";
import validation4 from "./schema/validations4";
import Table4 from "./components/table4";
import Fields5 from "./components/field5";
import form5 from "./schema/form5";
import initialValues5 from "./schema/initialValues5";
import validation5 from "./schema/validations5";
import Table5 from "./components/table5";

export default function TaxValue01() {
  const { formId, formField } = form;
  const { formId2, formField2 } = form2;
  const { formId3, formField3 } = form3;
  const { formId4, formField4 } = form4;
  const { formId5, formField5 } = form5;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([
    { name: "01-2/GTGT", checked: false },
    { name: "01-6/GTGT (CSSX)", checked: false },
    { name: "01-6/GTGT (ĐTVT)", checked: false },
    { name: "PL 101/2023/QH15", checked: false },
  ]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế giá trị gia tăng (Mẫu số 01/GTGT)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với người nộp thuế tính thuế theo phương pháp khấu trừ có hoạt động sản
                xuất kinh doanh)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng phân bổ số thuế giá trị gia tăng phải nộp
              </Typography>
              <Typography variant="h4" textTransform="uppercase">
                đối với hoạt động sản xuất thuỷ điện
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo Tờ khai mẫu 01/GTGT)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues2}
              validationSchema={validation2}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId2} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField2,
                      errors,
                    }}
                  />
                  <Table2 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng phân bổ số thuế giá trị gia tăng phải nộp
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Trừ hoạt động sản xuất thuỷ điện, hoạt động kinh doanh sổ số điện toán)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo Tờ khai mẫu 01/GTGT)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues3}
              validationSchema={validation3}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId3} autoComplete="off">
                  <Fields3
                    formData={{
                      values,
                      touched,
                      formField3,
                      errors,
                    }}
                  />
                  <Table3 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 3 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng phân bổ số thuế giá trị gia tăng phải nộp
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Trừ hoạt động sản xuất thuỷ điện, hoạt động kinh doanh sổ số điện toán)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo Tờ khai mẫu 01/GTGT)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues4}
              validationSchema={validation4}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId4} autoComplete="off">
                  <Fields4
                    formData={{
                      values,
                      touched,
                      formField4,
                      errors,
                    }}
                  />
                  <Table4 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 4 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục giảm thuế giá trị gia tăng theo nghị quyết số 101/2023/QH15
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Kèm theo Tờ khai thuế GTGT kỳ tính thuế Quý 3 năm 2023)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues5}
              validationSchema={validation5}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId5} autoComplete="off">
                  <Fields5
                    formData={{
                      values,
                      touched,
                      formField5,
                      errors,
                    }}
                  />
                  <Table5 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    nameOfProductionBusinessActivities,
    contractNumber,
    contractDay,
    dependentUnitName,
    dependentUnitNameTaxId,
    addressWard,
    addressDistrict,
    addressCity,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={nameOfProductionBusinessActivities.name}
            label={nameOfProductionBusinessActivities.label}
            value={values.nameOfProductionBusinessActivities}
            error={
              errors.nameOfProductionBusinessActivities &&
              touched.nameOfProductionBusinessActivities
            }
            success={
              values.nameOfProductionBusinessActivities?.toString().length > 0 &&
              !errors.nameOfProductionBusinessActivities
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contractNumber.name}
            label={contractNumber.label}
            value={values.contractNumber}
            error={errors.contractNumber && touched.contractNumber}
            success={values.contractNumber?.toString().length > 0 && !errors.contractNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={contractDay.name}
            label={contractDay.label}
            error={errors.contractDay && touched.contractDay}
            success={values.contractDay?.toString().length > 0 && !errors.contractDay}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={dependentUnitName.name}
            label={dependentUnitName.label}
            value={values.dependentUnitName}
            error={errors.dependentUnitName && touched.dependentUnitName}
            success={values.dependentUnitName?.toString().length > 0 && !errors.dependentUnitName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={dependentUnitNameTaxId.name}
            label={dependentUnitNameTaxId.label}
            value={values.dependentUnitNameTaxId}
            error={errors.dependentUnitNameTaxId && touched.dependentUnitNameTaxId}
            success={
              values.dependentUnitNameTaxId?.toString().length > 0 && !errors.dependentUnitNameTaxId
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={12}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            [11] Địa chỉ nơi có hoạt động sản xuất kinh doanh khác tỉnh nơi đóng trụ sở chính:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressCity.name}
            label={addressCity.label}
            value={values.addressCity}
            error={errors.addressCity && touched.addressCity}
            success={values.addressCity?.toString().length > 0 && !errors.addressCity}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressDistrict.name}
            label={addressDistrict.label}
            value={values.addressDistrict}
            error={errors.addressDistrict && touched.addressDistrict}
            success={values.addressDistrict?.toString().length > 0 && !errors.addressDistrict}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressWard.name}
            label={addressWard.label}
            value={values.addressWard}
            error={errors.addressWard && touched.addressWard}
            success={values.addressWard?.toString().length > 0 && !errors.addressWard}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
